<template>
  <div>
    <CardcountTerminal />
    <rabbey-toolbox
      filter-placeholder="Buscar por nombre"
      filterables
      @filter-search="search = $event"
    />

    <rabbey-table3
      ref="companyTable"
      :search="search"
      :border="true"
      :stripe="true"
      :columns="Columns"
      v-loading="loading_company"
      :data="companies"
      :show-summary="true"
      :pageSizes="[10, 20, 50, 100, 200, 500]"
      :summary-method="getSummariesEmpresa"
    />

    <!-- set drawer services -->
    <el-drawer
      :title="label"
      :visible.sync="drawer"
      :before-close="before"
      size="75%"
    >
      <div>
        <el-row>
          <rabbey-table3
            :height="750"
            style="overflow: auto"
            ref="ServicesTable"
            :columns="ColumnsServices"
            :border="true"
            :stripe="true"
            v-loading="loading_services"
            :data="services"
          />
        </el-row>
      </div>
    </el-drawer>
    <!-- Customer -->
    <el-drawer
      title="Cartera de clientes"
      :visible.sync="drawerCust"
      :before-close="before"
      size="75%"
    >
      <div>
        <el-row>
          <rabbey-table3
            :height="750"
            style="overflow: auto"
            ref="customerTable"
            :columns="ColumnsCustomer"
            v-loading="loading_customer"
            :border="true"
            :stripe="true"
            :data="customers"
            :show-summary="true"
            :summary-method="getSummaries"
          />
        </el-row>
      </div>
    </el-drawer>

    <el-drawer
      title="Cartera de clientes activos"
      :visible.sync="show_customer_ACT"
      :before-close="before"
      size="75%"
    >
      <div>
        <el-row>
          <rabbey-table3
            :height="750"
            style="overflow: auto"
            ref="customerTable"
            :columns="ColumnsCustomer"
            v-loading="loading_customer"
            :border="true"
            :stripe="true"
            :data="customersACT"
            :show-summary="true"
            :summary-method="getSummaries"
          />
        </el-row>
      </div>
    </el-drawer>

    <el-drawer
      title="Cartera de clientes Inactivos"
      :visible.sync="show_customer_INA"
      :before-close="before"
      size="75%"
    >
      <div>
        <el-row>
          <rabbey-table3
            :height="750"
            style="overflow: auto"
            ref="customerTable"
            :columns="ColumnsCustomer"
            :border="true"
            :stripe="true"
            v-loading="loading_customer"
            :data="customersINA"
            :show-summary="true"
            :summary-method="getSummaries"
          />
        </el-row>
      </div>
    </el-drawer>

    <el-drawer
      title="Terminales instaladas"
      :visible.sync="show_terminal"
      :before-close="before"
      size="75%"
    >
      <div>
        <el-row>
          <rabbey-table3
            :height="750"
            style="overflow: auto"
            ref="terminalsTable"
            :border="true"
            :stripe="true"
            :columns="ColumnsTerminales"
            v-loading="loading_terminales"
            :data="terminals"
          />
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  Columns,
  ColumnsServices,
  ColumnsCustomer,
  ColumnsTerminales
} from "./columnsTables/CompaniesColumns";
import { mapState, mapGetters } from "vuex";
import { formatMonto } from "@/utils";
import CardcountTerminal from "@/views/apps/ncfmovil/CardsTerminal.vue";
export default {
  name: "EmpresasList",
  components: { CardcountTerminal },
  computed: {
    ...mapState({
      loading_company: (state) => state.ncfmovil.loading_company,
      loading_services: (state) => state.ncfmovil.loading_services,
      loading_customer: (state) => state.ncfmovil.loading_customer,
      loading_terminales: (state) => state.ncfmovil.loading_terminales,
      companies: (state) => state.ncfmovil.companies,
      services: (state) => state.ncfmovil.terminalsAndServices,
      customers: (state) => state.ncfmovil.customers,
      customersACT: (state) => state.ncfmovil.customersACT,
      customersINA: (state) => state.ncfmovil.customerINA,
      terminals: (state) => state.ncfmovil.terminals,
      drawer: (state) => state.ncfmovil.show_services,
      drawerCust: (state) => state.ncfmovil.show_customer,
      show_customer_ACT: (state) => state.ncfmovil.show_customer_ACT,
      show_customer_INA: (state) => state.ncfmovil.show_customer_INA,
      show_terminal: (state) => state.ncfmovil.show_terminal
    }),
    ...mapGetters(["label", "service_view"])
  },
  created: async function () {
    this.$store.dispatch("getAllCompany");
  },
  data() {
    return {
      Columns,
      ColumnsServices,
      ColumnsCustomer,
      ColumnsTerminales,
      search: ""
    };
  },
  methods: {
    formatMonto,
    before() {
      this.$store.dispatch("hide", false);
    },
    hanlderClose() {},
    getSummariesEmpresa(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 1) {
          return;
        }
        if (index === 1) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 6) {
          return;
        }
        if (index === 6) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    }
  }
};
</script>

<style></style>
